(() => {
 function init(root) {
  root.querySelectorAll('[data-oc-product]').forEach(section => {
   if (section.dataset.ready) return;
   section.dataset.ready = '1';
   const form = section.querySelector('[data-oc-form]'), main = section.querySelector('[data-oc-main]'), button = section.querySelector('[data-oc-submit]'), status = section.querySelector('[data-oc-status]');
   const sync = () => {
    const selected = form.querySelector('.oc-variants input[type=radio]:checked');
    if (!selected) return;
    form.querySelector('[data-oc-id]').value = selected.value;
    const cents = Number(selected.dataset.cents);
    const format = amount => new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {style:'currency',currency:window.Shopify?.currency?.active || 'PLN'}).format(amount / 100);
    const bundle = form.querySelector('[data-percent]:checked');
    const quantity = Number(bundle?.value || 1);
    form.querySelector('[data-oc-qty]').value = quantity;
    const percent = Number(bundle?.dataset.percent || 0);
    section.querySelector('[data-oc-price]').textContent = format(Math.round(cents * quantity * (100-percent)/100));
    form.querySelectorAll('[data-oc-bundle-price]').forEach(el => {
      const n = Number(el.dataset.ocBundlePrice), discount = n===3 ? 10 : n===2 ? 5 : 0;
      el.textContent = format(Math.round(cents*n*(100-discount)/100));
    });
    form.querySelectorAll('[data-oc-regular]').forEach(el => {const n=Number(el.dataset.ocRegular);el.textContent=n>1 ? format(cents*n) : '';});
    main.src = selected.dataset.image;
    button.disabled = selected.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Niedostępny' : 'Dodaj zestaw do koszyka';
    const url = new URL(location.href); url.searchParams.set('variant', selected.value); history.replaceState(null, '', url);
   };
   form.querySelectorAll('input[type=radio]').forEach(input => input.addEventListener('change', sync));
   section.querySelectorAll('[data-oc-image]').forEach(b => b.addEventListener('click', () => { main.src = b.dataset.ocImage; }));
   form.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.dataset.busy || button.disabled) return;
    form.dataset.busy = '1'; button.disabled = true; button.setAttribute('aria-busy','true');
    form.querySelectorAll('input[type=radio]').forEach(input => { input.disabled = true; });
    status.textContent = 'Dodajemy do koszyka…';
    let added = false;
    try {
     const { CartLinesUpdateEvent } = await import('@shopify/events');
     const rootUrl = window.Shopify?.routes?.root || '/';
     const body = new FormData(form);
     const ids = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0,5);
     if(ids.length) body.set('sections', ids.join(','));
     body.set('sections_url', location.pathname);
     const response = await fetch(rootUrl+'cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});
     const result = await response.json();
     if(!response.ok) throw new Error(result.description || 'Nie udało się dodać produktu. Spróbuj ponownie.');
     added = true;
     const cartResponse = await fetch(rootUrl+'cart.js');
     if(!cartResponse.ok) throw new Error('refresh');
     const cart = await cartResponse.json();
     form.dispatchEvent(new CartLinesUpdateEvent({action:'add', context:'product', lines:[{merchandiseId:body.get('id'),quantity:Number(body.get('quantity'))}],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:result.sections,source:'otulsi-catalog',itemCount:cart.item_count,didError:false}})}));
     status.textContent='Dodano do koszyka ✓ Możesz kontynuować zakupy.';
    } catch(error) {
     status.textContent=added ? 'Produkt dodany. Otwórz koszyk, aby sprawdzić zamówienie.' : error.message;
    } finally {
     delete form.dataset.busy; button.removeAttribute('aria-busy');
     form.querySelectorAll('input[type=radio]').forEach(input => { input.disabled=false; });
     sync();
    }
   });
  });
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
